import React from "react";
import "./History_Expert.css";
import Common_History_Expert from "../../../common_components/common-history-expert/Common_History_Expert";
import Common_Rate_Btn from "../../../common_components/common-rate-btn/Common_Rate_Btn";

const experts = [
  {
    id: 1,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 2,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 3,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 4,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 5,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 6,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 7,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 8,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 9,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 10,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 11,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
  {
    id: 12,
    detailsId: "#ORD12345",
    name: "Shubham Mane",
    field: "Plumbing Repair",
    experience: "6 Years",
    age: "28",
    image: "/assets/images/expert2.png",
  },
];

function History_Expert({ vendorexpertlist }) {
  const historyData = vendorexpertlist?.data || [];
  return (
    <div className="container mt-4 history-section">
      <div className="row">
        {historyData?.length ? (
          historyData?.map((item) => (
            <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4">
              <Common_History_Expert data={item} />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p className="text-muted">No data found</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default History_Expert;
